const styles = theme => ({
  // stepperopnerListMulti: {},
  // stepperItem: {},
  // stepperopnerList: {
  //   padding: "0",
  //   "& $label": {
  //     fontSize: "10px",
  //   },
  //   "& $labellistActive": {
  //     color: "#1C999B",
  //     fontWeight: "600",
  //   },
  //   "& button": {
  //     padding: "7px",
  //     color: "#342D3D",
  //     margin: "0",
  //     justifyContent: "center",
  //     "& $activeIcon": {
  //       color: "#1FCACC",
  //       "& $completed": {
  //         fill: "#fff",
  //       },
  //     },
  //     "&:hover": {
  //       background: "#EFFBFC",
  //       "& $completed": {
  //         fill: "#1C999B",
  //       },
  //       "& $label": {
  //         color: "#1C999B",
  //         fontWeight: "600",
  //       },
  //     },
  //   },
  //   "& $stepperopnerActive": {
  //     background: "#EFFBFC",
  //   },
  // },
  // stepperopnerActive: {},
  // listingiconRoot: {
  //   color: "#F8F8F8",
  // },
  // completed: {
  //   fill: "#565960",
  //   fontSize: "14px",
  //   fontWeight: "400",
  // },
  // activeIcon: {},
  // label: {},
  // labellistActive: {},
  // stepButtonComplete: {
  //   "& > span > span:first-child > svg": {
  //     color: theme.palette.primary.adgmGreen,
  //   },
  //   "& > span > span:last-child > span": {
  //     color: theme.palette.primary.adgmGreen,
  //   },
  // },
  gotoproBtn: {
    margin: 'auto',
    display: 'block',
    height: '60px',
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '16px',
    width: '100%',
    maxWidth: '350px',
    marginTop: '32px',
    textTransform: 'none',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  panels: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '30px',
    },
  },
  workflowContainer: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '70px',
    },
  },
  navigatorContainer: {
    display: 'flex',
    '& button': {
      minWidth: '151px',
      padding: '15px',
      height: '56px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '4px',
      color: '#fff',
      textTransform: 'capitalize',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    '& $nextButton': {
      background: theme.palette.primary.main,
      marginLeft: 'auto',
      '& img': {
        marginLeft: '8px',
      },
      '&:disabled': {
        backgroundColor: theme.palette.primary.darkGrey,
        cursor: 'not-allowed !important',
      },
    },
    '& $backButton': {
      color: '#342D3D',
      border: '1px solid #342D3D',
      '& img': {
        marginRight: '8px',
      },
      '&:disabled': {
        backgroundColor: '#EBEEF3',
        color: '#CED1D6',
        border: '1px solid #CED1D6',
        cursor: 'not-allowed !important',
      },
    },
  },
  nextButton: {},
  backButton: {},
  cancelBtn: {
    borderTop: '1px solid #EBEEF3',
    borderRadius: 'none',
    padding: '10px',
    '&::after': {
      display: 'none',
    },
    '& span': {
      color: '#D2374F',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
    },
  },
  // [theme.breakpoints.up("md")]: {
  //   stepperopnerList: {
  //     padding: "0",
  //     "& span": {
  //       border: "0",
  //     },
  //     "& $label": {
  //       color: "#342D3D",
  //       marginBottom: "4px",
  //       fontSize: "14px",
  //     },
  //     "& $labellistActive": {
  //       color: "#1C999B",
  //       fontWeight: "600",
  //     },
  //     "& button": {
  //       padding: "12px 20px 12px 0",
  //       borderRadius: "10px",
  //       boxSizing: "border-box",
  //       color: "#342D3D",
  //       margin: "0",
  //       justifyContent: "flex-start",
  //       textAlign: "left",
  //       "& $activeIcon": {
  //         color: "transparent",
  //         "& $completed": {
  //           fill: "#1C999B",
  //         },
  //       },
  //       "&:hover": {
  //         background: "#EFFBFC",
  //         "& $completed": {
  //           fill: "#1C999B",
  //         },
  //         "& $label": {
  //           color: "#1C999B",
  //           fontWeight: "600",
  //         },
  //       },
  //     },
  //     "& $stepperopnerActive": {
  //       background: "#EFFBFC",
  //     },
  //   },
  //   listingiconRoot: {
  //     color: "transparent",
  //   },
  //   completed: {
  //     fill: "#342D3D",
  //     fontSize: "20px",
  //     fontWeight: "500",
  //   },
  // },

  [theme.breakpoints.down('sm')]: {
    stepperopnerListMulti: {
      gridTemplateColumns: 'repeat(6, 1fr) !important',
    },
    // stepperopnerList: {
    //   marginTop: "20px",
    //   flexDirection: "row",
    //   display: "grid",
    //   gridTemplateColumns: "repeat(5, 1fr)",
    //   "& $stepperItem:not(:last-of-type) button": {
    //     "&::after": {
    //       content: '""',
    //       background: "#bdbdbd",
    //       height: "1px",
    //       top: "18px",
    //       left: "calc(50% + 12px)",
    //       right: "calc(-50% + 12px)",
    //       position: "absolute",
    //     },
    //   },
    //   "& > div": {
    //     "&:last-child button": {
    //       "&:after": {
    //         background: "transparent",
    //       },
    //     },
    //   },
    //   "& $label": {
    //     whiteSpace: "normal",
    //   },
    // },
    cancelBtn: {
      borderTop: 'none',
    },
    // MuiStepLabelRoot: {
    //   flexDirection: "column",
    // },
    // MuiStepLabeliconContainer: {
    //   paddingRight: "0",
    //   marginBottom: "4px",
    // },
    // mobileTitlehead: {
    //   display: "block",
    // },
    navigatorContainer: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      width: '98%',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1',
      '& button': {
        width: '100%',
        margin: '0 5px',
        height: '48px',
      },
      '& $nextButton': {
        margin: '0 5px',
      },
    },
  },
  [theme.breakpoints.down('xs')]: {
    navigatorContainer: {
      bottom: '70px',
    },
  },
  '@media (max-width:600px)': {
    cancelBtn: {
      position: 'fixed',
      top: '8px',
      right: '0',
      zIndex: '999',
      '& span span': {
        display: 'none',
      },
    },
  },

  // stepper V2

  StepperContainer: {
    padding: '0px',
    // border: '1px solid #CED1D6',
    borderRadius: '0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflowX: ' auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap',
  },

  StepperInnerContainer: {
    background: '#F8F8F8',
    borderRadius: '6px',
    '& button': {
      padding: '0px !important',
      margin: '0px',
      fontStyle: 'italic',
      display: 'flex',
      justifyContent: 'start',
    },
    '& div': {
      padding: '8px !important',
      [theme.breakpoints.down('xs')]: {
        marginTop: '12px',
      },
    },
  },
  MuiStepLabeliconContainer: {
    // height: '16px',
    position: 'relative',
    paddingRight: '0',
    '& svg': {
      fontSize: '20px',
      color: '#fff !important',
    },
    '& text': {
      fill: '#595B61 !important',
      fontSize: '16px',
    },
  },
  MuiStepLabelRoot: {
    paddingLeft: '0px',
    '& span': {
      fontSize: '16px !important',
      fontWeight: '500 !important',
      color: '#595B61',
    },
  },

  StepperHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    paddingBottom: '17px',
    padding: '16px',
    borderBottom: '1px solid #EBEEF3',
    '& img': {
      cursor: 'pointer',
      width: '20px',
      height: '20px',
    },
  },
  StepperTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#484456',
  },
  ACTIVE: {
    // backgroundColor: theme.palette.secondary.dim,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    '& span': {
      fontWeight: '600 !important',
      color: '#0D2A3A',
    },
    '& text': {
      fontWeight: '600 !important',
      fill: '#0D2A3A !important',
    },
  },
  stepsCount: {
    fontSize: '18px',
    color: '#344054',
    fontWeight: '500',
    textAlign: 'end',
    display: 'flex',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      marginTop: '12px',
    },
  },
  countBlock: {
    alignSelf: 'center',
  },
  // stepButtonComplete: {
  //   '& > span > span:first-child > svg': {
  //     color: theme.palette.secondary.main ,
  //     '&:after': {
  //       background: 'red',
  //     },
  //   },
  //   '& > span > span:last-child > span': {
  //     color: theme.palette.secondary.main,
  //   },
  // },
  stepperopnerList: {
    background: '#F8F8F8',
    padding: '0',
    '& $label': {
      fontSize: '12px',
    },
    '& $labellistActive': {
      color: theme.palette.secondary.main,
      fontWeight: '600',
    },
    '& button': {
      padding: '7px',
      width: '100%',
      color: theme.palette.secondary.main,
      margin: '0',
      justifyContent: 'center',
      '& $activeIcon': {
        color: theme.palette.secondary.main,
        '& $completed': {
          fill: '#fff',
        },
      },
    },
    '& $stepperopnerActive': {
      background: '#EFFBFC',
    },
  },
  listingiconRoot: {
    color: 'transparent !important',
  },
  completed: {
    fill: '#565960',
    fontSize: '14px',
    fontWeight: '400',
  },
  activeIcon: {
    marginTop: '4px',
    fontWeight: '600',
  },
  label: {},
  labellistActive: {},

  '@media (min-width:768px)': {
    stepperopnerList: {
      padding: '0',
      '& span': {
        border: '0',
      },
      '& $label': {
        color: theme.palette.secondary.main,
        // marginBottom: "4px",
        fontSize: '16px',
      },
      '& $labellistActive': {
        color: '#EEE',
        fontWeight: '600',
      },
      '& button': {
        padding: '13.5px 20px 13.5px 0',
        borderRadius: '10px',
        boxSizing: 'border-box',
        color: theme.palette.secondary.main,
        margin: '0',
        justifyContent: 'flex-start',
        textAlign: 'left',
        '& $activeIcon': {
          color: 'transparent',
          '& $completed': {
            fill: '#EEE',
          },
        },
      },
      '& $stepperopnerActive': {
        background: '#EFFBFC',
      },
    },
    listingiconRoot: {
      color: 'transparent',
    },
    completed: {
      fill: theme.palette.secondary.main,
      fontSize: '20px',
      fontWeight: '400',
    },
  },

  '@media (max-width:767px)': {
    StepperContainer: {
      border: 'none',
      marginRight: '24px',
    },
    StepperInnerContainer: {
      background: 'none',
    },
    flex1: {
      flex: `1 !important`,
    },
    RootStep: {
      flex: '0 0 20%',
      position: 'relative',
      '&:not(:last-child)': {
        '&:before': {
          content: "''",
          background: theme.palette.secondary.dim,
          display: 'block',
          width: '74%',
          height: '1px',
          right: '-45%',
          top: '23%',
          // transform: 'translateY(-50%)',
          position: 'absolute',
          zIndex: '2',
        },
      },
    },
    RootStepMultiple: {
      flex: '0 0 16.6%',
      position: 'relative',
      '&:not(:last-child)': {
        '&:before': {
          content: "''",
          background: theme.palette.secondary.dim,
          display: 'none',
          width: '74%',
          height: '1px',
          right: '-45%',
          top: '23%',
          // transform: 'translateY(-50%)',
          position: 'absolute',
          zIndex: '2',
        },
      },
    },

    ACTIVE: {
      backgroundColor: '#FFF',
      color: theme.palette.secondary.main,
    },
    StepperHeader: {
      display: 'none',
    },

    stepperopnerList: {
      background: 'none',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      width: '100%',
      '& $label': {
        whiteSpace: 'normal',
        marginTop: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '40px',
      },

      '& $labellistActive': {
        color: theme.palette.secondary.main,
      },
      '& $activeIcon': {
        color: '#EBEEF3 !important',
        border: '1.5px solid #342D3D',
        borderRadius: '50%',
        marginTop: '0px',
        '& $completed': {
          fill: '#342D3D !important',
        },
      },
    },
    MuiStepLabelRoot: {
      // flexDirection: 'column',
      paddingLeft: '0',
    },
    MuiStepLabeliconContainer: {
      paddingRight: '0',
    },
  },

  rotateArrow: {
    '& img': {
      marginRight: '8px',
      transform: 'rotate(180deg)',
    },
  },

  footerClass: {
    padding: '16px 0px',
    boxShadow: '0px -1px 8px 0px #0000001A',
    position: 'absolute',
    left: '0',
    right: '0',
    bottom: '0',
  },

  outerFooterContainer: {
    maxWidth: '1280px !important',
    marginRight: 'auto',
    marginLeft: 'auto',
  },

  footerContainer: {
    marginLeft: 'auto',
    padding: '0px 0px 0px 8px',
  },

  '@media (min-width: 600px)': {
    outerFooterContainer: {
      padding: '0px 24px',
    },
  },
});

export default styles;
